var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AudioSearch',{attrs:{"icon":_vm.icon,"label":_vm.label,"title":_vm.title,"route":_vm.route,"color":_vm.color,"status":_vm.status,"show-revisor":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }